import _Object$assign from '@babel/runtime-corejs3/core-js-stable/object/assign';
import { c as classNames } from '../../shared/bind-a2a3a613.js';
import { s as styles } from '../../shared/Carousel-2648971e.js';
import { Icon } from '../Icon/Icon.js';
import { jsx } from 'react/jsx-runtime';
import _objectSpread from '@babel/runtime-corejs3/helpers/esm/objectSpread2';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/esm/objectWithoutProperties';
import * as React from 'react';

var _excluded$1 = ["title", "titleId"];
var ChevronLeft16 = function ChevronLeft16(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1);
  return /* @__PURE__ */React.createElement("svg", _objectSpread({
    fill: "none",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    "aria-labelledby": titleId
  }, props), title ? /* @__PURE__ */React.createElement("title", {
    id: titleId
  }, title) : null, /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    d: "M10.53 2.47a.75.75 0 0 1 0 1.06L6.06 8l4.47 4.47a.75.75 0 1 1-1.06 1.06l-5-5a.75.75 0 0 1 0-1.06l5-5a.75.75 0 0 1 1.06 0"
  }));
};
ChevronLeft16.Size = 16;
ChevronLeft16.Title = "ChevronLeft";

var _excluded = ["title", "titleId"];
var ChevronRight16 = function ChevronRight16(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /* @__PURE__ */React.createElement("svg", _objectSpread({
    fill: "none",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    "aria-labelledby": titleId
  }, props), title ? /* @__PURE__ */React.createElement("title", {
    id: titleId
  }, title) : null, /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    d: "M5.47 2.47a.75.75 0 0 0 0 1.06L9.94 8l-4.47 4.47a.75.75 0 1 0 1.06 1.06l5-5a.75.75 0 0 0 0-1.06l-5-5a.75.75 0 0 0-1.06 0"
  }));
};
ChevronRight16.Size = 16;
ChevronRight16.Title = "ChevronRight";

var CAROUSEL_ARROW_SIDE_VALUES = ['left', 'right'];
/* ---------- Back-compat shims (public API) ---------- */
var CAROUSEL_ARROW_SIDE = {
  Left: 'left',
  Right: 'right'
};

/* ---------- Type definitions ---------- */

var cssClasses = classNames.bind(styles);
var CarouselArrowBase = function CarouselArrowBase(_ref) {
  var side = _ref.side,
    onClick = _ref.onClick;
  return /*#__PURE__*/jsx("button", {
    type: "button",
    "data-testid": "carousel-".concat(side, "-arrow"),
    className: cssClasses('arrow', "".concat(side, "-arrow")),
    onClick: onClick,
    role: "menuitem",
    tabIndex: 0,
    children: /*#__PURE__*/jsx(Icon, {
      name: side === CAROUSEL_ARROW_SIDE.Left ? ChevronLeft16 : ChevronRight16,
      color: "greyscale-level-6"
    })
  });
};

/** The public component type: a React component value that also has deprecated statics */

/** Exported component: arrow fn + statics, deprecations intact, docgen-friendly */
var CarouselArrow = _Object$assign(CarouselArrowBase, {
  /** @deprecated Use string unions, e.g. side="left" */
  Side: CAROUSEL_ARROW_SIDE
});

export { CAROUSEL_ARROW_SIDE, CAROUSEL_ARROW_SIDE_VALUES, CarouselArrow, CarouselArrow as default };
//# sourceMappingURL=CarouselArrow.js.map
